import { ReactComponent as Clock } from 'images/icons/ClockFilled.svg';
import './ComingSoonTag.scss';
import { useTranslation } from 'react-i18next';

type ComingSoonTagProps = {
  isAdmin: boolean;
};

export const ComingSoonTag = ({ isAdmin }: ComingSoonTagProps) => {
  const { t } = useTranslation();

  return (
    <div className='coming-soon-tag'>
      {isAdmin ? <Clock className='icon' /> : <></>}
      <div className='coming-soon-tag-text'>{isAdmin ? 'Coming Soon For User' : t('ComingSoon', { ns: 'learningHub' })}</div>
    </div>
  );
};
